/**
 * WHAT /api/vin SAID, AS THE BOX UNDER A DECODE BUTTON.
 *
 * Three screens decode a VIN (adding a car to a job, the job's own VIN,
 * and a lead) and they each drew this box by hand. Since 2026-09-26 an RV
 * answer carries `rv`: whether it is a towable or the chassis under a
 * motorhome, its style, length and GVWR, and one sentence saying what the
 * VIN does not cover. One renderer, so the three cannot drift on it.
 */
import { esc } from "./dom.ts";

type Rv = { kind?: string; style?: string; lengthFt?: number; gvwr?: string; note?: string };

const KIND: Record<string, string> = {
  towable: "Towable RV",
  "motorhome-chassis": "Motorhome chassis",
  "van-chassis": "Van chassis",
};

/** The box. `bits` false is the compact form: the heading, the RV facts and the note. */
export function vinOutHtml(d: Record<string, unknown>, { bits = true }: { bits?: boolean } = {}): string {
  const rv = (d["rv"] && typeof d["rv"] === "object" ? d["rv"] : null) as Rv | null;
  const chips = [
    ...(bits ? ["trim", "engine", "fuel", "body", "drive"].map((k) => d[k]) : []),
    rv?.kind ? KIND[rv.kind] ?? "" : "",
    rv?.style ?? "",
    rv?.lengthFt ? `${rv.lengthFt} ft` : "",
    rv?.gvwr ? `GVWR ${rv.gvwr}` : "",
  ].filter(Boolean);
  return `<div class="vinout">
      <div class="vin-h">${esc(String(d["label"] ?? ""))}</div>
      ${chips.length ? `<div class="vin-bits">${chips.map((c) => `<span>${esc(String(c))}</span>`).join("")}</div>` : ""}
      ${rv?.note ? `<div class="fine">${esc(rv.note)}</div>` : ""}
      ${d["warning"] ? `<div class="fine">${esc(String(d["warning"]))}</div>` : ""}
    </div>`;
}
